export default __webpack_public_path__ + "static/media/Logos_gold_shadow.32e76c29.png";